import { useCallback, useEffect, useState,useRef } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { connect } from "react-redux";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import * as RoleHelper from "../../../../helpers/RoleHelper";
import * as ListCellRenders from "../../../common/list/ListCellRenders";
import { AccessScopeConstants, RouteConstants } from "../../../../constants";
import {
//   listRequest,
//   setQuery,
  deleteRequest,
} from "../../../../store/slices/audienceSlice";
// import {
//   userExportRequest,
// } from "../../../../store/slices/usersSlice";
import {
     GetNotificationLogsSuccess,
  GetNotificationLogsFailure,
  GetNotificationLogs,
  listRequest,
    setQuery,
    notificationExportRequest
} from "../../../../store/slices/notificationSlice";
import List from "../../../common/list";
import { Dialog } from "primereact/dialog";
// import AudienceUserList from "./AudienceUserList";
import { TextInput } from "../../../common/fields";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import useMobileView from "../../../common/hooks/useMobileView";
import { Menu } from "primereact/menu";
import DropdownButton from "../../../common/dropDownButton";

const NotificationLogList = ({
  labels,
  user,
  audiences,
  listRequest,
  action,
  error,
  query,
  requesting,
  setQuery,
  totalCount,
  isFromAssigment = false,
  deleteRequest,
  getNotificationLogs,
  notificationLogs,
  filters,
  notificationExportRequest
}) => {
  const navigate = useNavigate();
  const [isUserListDialogVisible, setUserListDialogVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [namePattern, setNamePattern] = useState("");
  const [createdByNamePattern, setCreatedByNamePattern] = useState("");

  const intl = useIntl();

  const { isMobile } = useMobileView();

  const { role } = user || {};
  const menuRef = useRef();

  const canAdd = RoleHelper.checkRoleScope(
    role?.scope,
    AccessScopeConstants.UserAccess,
    AccessScopeConstants.CreateScope
  );

  const canDelete = RoleHelper.checkRoleScope(
    role?.scope,
    AccessScopeConstants.UserAccess,
    AccessScopeConstants.DeleteScope
  );

//   const fetchList = useCallback(() => {
//     listRequest({
//       ...query,
//     });
//   }, [query, listRequest]);

//   useEffect(() => {
//     fetchList();
//   }, [fetchList]);

//   useEffect(() => {
//     if (
//       !requesting &&
//       !error &&
//       (action === "create" || action === "update" || action === "delete")
//     ) {
//       fetchList();
//     }
//   }, [action, requesting, error]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (query?.namePattern !== namePattern) {
        setQuery({ ...query, namePattern, pageNo: 1 });
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [namePattern, setQuery, query]);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (query?.createdBy !== createdByNamePattern) {
//         setQuery({ ...query, createdBy: createdByNamePattern, pageNo: 1 });
//       }
//     }, 500);

//     return () => clearTimeout(timer);
//   }, [createdByNamePattern, setQuery, query]);

  const handleAddAudience = () => {
    navigate(RouteConstants.APP_ROUTE_ADMINISTRATION_AUDIENCES_ADD);
  };

  const handlePageChange = (pageData) => {
    if (
      query.pageSize !== pageData.rows ||
      query.pageNo !== pageData.page + 1
    ) {
      setQuery({
        ...query,
        pageNo: pageData.page + 1,
        pageSize: pageData.rows,
      });
    }
  };

  const handleOnSortChange = (sortData) => {
    setQuery({
      ...query,
      pageNo: 1,
      sortColumn: sortData.sortField,
      sortBy: sortData.sortOrder === 1 ? "asc" : "desc",
    });
  };

  const onUserList = (id) => {
    setSelectedId(id);
    setUserListDialogVisible(true);
  };

  const onClone = (id) => {
    navigate(
      `${RouteConstants.APP_ROUTE_ADMINISTRATION_AUDIENCES_ADD}?clone=${id}`
    );
  };

  const onDeleteAction = (data) => {
    confirmDialog({
      message: intl.formatMessage(
        { id: "delete_object_message" },
        {
          name: data.name,
          object: intl.formatMessage({ id: "notification_audit" }),
        }
      ),
      header: intl.formatMessage({ id: "delete_confirmation" }),
      icon: "pi pi-info-circle",
      defaultFocus: "reject",
      acceptClassName: "p-button-danger",
      rejectClassName: "p-button-secondary",
      accept: () => {
        deleteRequest({ id: data.id });
      },
      reject: () => {},
    });
  };

  let otherActions = [
    {
      label: "view_users",
      icon: "pi pi-users",
      isAllowed: true,
      action: (data) => onUserList(data.id),
    },
  ];

  if (!isFromAssigment) {
    otherActions.push({
      label: "clone",
      icon: "pi pi-clone",
      isAllowed: canAdd,
      action: (data) => onClone(data.id),
    });
    otherActions.push({
      label: "delete",
      icon: "pi-trash",
      isAllowed: canDelete,
      additionalCheckNotAllowedMessage: "no_permission_delete_message_cohort",
      additionalCheckForAllowed: (data) => data.canBeDeleted,
      action: (data) => onDeleteAction(data),
    });
  }

//   const fetchLogs = useCallback(() => {
//   getNotificationLogs();
// }, [getNotificationLogs]);

// useEffect(() => {
//   fetchLogs();
// }, [fetchLogs]);

useEffect(() => {
    console.log(query,"query param---->>>")
  getNotificationLogs(query);
}, [query, getNotificationLogs]);

//  const exportUsers = (fileType) => {
//     notificationExportRequest({
//       fileType,
//       query: {
//         ...query,
//         sortColumn:
//           query.sortColumn === "name" ? "firstName" : query.sortColumn,
//       },
//       filters: filters
//         .filter((item) => item.values.length > 0)
//         .map((item) => ({
//           id: item.id,
//           values: item.values,
//           isDynamicField:
//             item.id !== "Designation" &&
//             item.id !== "Department" &&
//             item.id !== "ManagerId",
//         })),
//     });
//   };

 const exportNotifications = (fileType) => {
      console.log("🚀 Dispatching export action:", fileType);

  notificationExportRequest({
    fileType,
    query: {
      ...query,
      sortColumn: query.sortColumn || "createdOn",
      sortBy: query.sortBy || "desc",
      pageNo: query.pageNo || 1,
      pageSize: query.pageSize || 50,
      namePattern: query.namePattern || "",
    },
    // filters: filters
    //   ?.filter((item) => item.values.length > 0)
    //   ?.map((item) => ({
    //     id: item.id,
    //     values: item.values,
    //     isDynamicField:
    //       item.id !== "Designation" &&
    //       item.id !== "Department" &&
    //       item.id !== "ManagerId",
    //   })),
  });
};

useEffect(() => {
  if (!query?.pageSize) {
    setQuery({
      pageNo: query?.pageNo || 1,
      pageSize: 50,
      sortBy: query?.sortBy || "desc",
      sortColumn: query?.sortColumn || "createdOn",
      namePattern: query?.namePattern || "",
    });
  }
}, []);

  return (
    <>
      <div>
        {(!isFromAssigment && (
          <CustomBreadCrumbs labels={labels} navigate={navigate} />
        )) ||
          null}
        <div
          className="edexlms-page-content"
          style={isFromAssigment ? { padding: 0 } : {}}
        >
          {(!isFromAssigment && (
            <div className="edexlms-page-header">
              <div className="edexlms-page-title">
                {intl.formatMessage({ id: "notification_audit" })}
              </div>
              {/* <div className="edexlms-page-actions">
                <Button
                  icon="pi pi-plus"
                  onClick={handleAddAudience}
                  size="small"
                  label={intl.formatMessage({ id: "add_audience" })}
                  type="button"
                  disabled={!canAdd}
                  tooltipOptions={{ showOnDisabled: true, position: "bottom" }}
                  tooltip={
                    canAdd ? "" : intl.formatMessage({ id: "no_permission" })
                  }
                />
              </div> */}
               <div className="edexlms-page-actions flex gap-2">
            {/* <SplitButton
              icon="pi pi-plus"
              onClick={handleAddUser}
              size="small"
              label={intl.formatMessage({ id: "add_user" })}
              type="button"
              disabled={!canAdd}
              tooltipOptions={{ showOnDisabled: true, position: "bottom" }}
              tooltip={
                canAdd ? "" : intl.formatMessage({ id: "no_permission" })
              }
              model={[
                {
                  label: intl.formatMessage({ id: "download_template" }),
                  icon: "pi pi-cloud-download",
                  command: () => {
                    downloadTemplateRequest();
                  },
                },
                {
                  label: intl.formatMessage({ id: "bulk_import" }),
                  icon: "pi pi-cloud-upload",
                  command: () => {
                    setIsImportDialogVisible(true);
                  },
                },
              ]}
            /> */}

            <div className="block md:hidden">
              <Button
                icon="pi pi-ellipsis-v"
                style={{
                  color: "var(--edexlms-primary-color)",
                  padding: 0,
                  width: "100%",
                  height: "30px",
                  fontSize: "2rem",
                  backgroundColor: "ButtonFace",
                }}
                onClick={(event) => menuRef.current.toggle(event)}
              ></Button>
              <Menu
                ref={menuRef}
                model={[
                  {
                    label: "Export",
                    icon: "pi pi-fw pi-plus",
                    disabled: true,
                    template: () => {
                      return (
                        <div>
                          <div className="flex align-items-center px-2 py-2 gap-2">
                            <i
                              className="pi pi-download"
                              style={{ fontSize: "1rem", fontWeight: "bold" }}
                            ></i>
                            <span
                              style={{
                                fontSize: "1.1rem",
                                fontWeight: "bold",
                              }}
                            >
                              Export
                            </span>
                          </div>
                          <ul className=" export-menu-container">
                            <li onClick={() => exportNotifications("excel")}>
                              - EXCEL{" "}
                            </li>
                            <li onClick={() => exportNotifications("csv")}>- CSV </li>
                            <li onClick={() => exportNotifications("pdf")}>- PDF</li>
                          </ul>
                        </div>
                      );
                    },
                  },
                //   {
                //     label: "Show staticstics",
                //     icon: "pi pi-fw pi-plus",
                //     disabled: true,
                //     template: () => {
                //       return (
                //         <div
                //           className="flex align-items-center px-2 py-2 gap-2 cursor-pointer"
                //           style={{ fontWeight: "bold" }}
                //           onClick={() => setIsmobileViewSummaryShown(true)}
                //         >
                //           <i className="pi pi-chart-bar" />
                //           Show staticstics
                //         </div>
                //       );
                //     },
                //   },
                ]}
                popup
                id="popup_menu_right"
                popupAlignment="right"
              />
            </div>

            <div className="hidden md:block">
              <DropdownButton
                icon="pi pi-download"
                label={intl.formatMessage({ id: "export" })}
                items={[
                  {
                    label: intl.formatMessage({ id: "excel" }),
                    command: () => exportNotifications("excel"),
                  },
                  {
                    label: intl.formatMessage({ id: "csv" }),
                    command: () => exportNotifications("csv"),
                  },
                  {
                    label: intl.formatMessage({ id: "pdf" }),
                    command: () => exportNotifications("pdf"),
                  },
                ]}
              />
            </div>
          </div>
            </div>
          )) ||
            null}
          <div className="edexlms-page-body">
            <div className="edexlms-search-filter-bar">
              <TextInput
                // style={{ width: "800px" }}
                className="wide-input"
                iconPosition="left"
                icon="pi-search"
                placeholder={intl.formatMessage({
                  id: "search-audit",
                })}
                input={{
                  name: "search",
                  value: namePattern,
                  onChange: (e) => setNamePattern(e.target.value),
                //   style: { width: "600px" }, // ✅ move style here
                }}
              />
              {/* <TextInput
                iconPosition="left"
                icon="pi-search"
                placeholder={intl.formatMessage({
                  id: "search_created_by",
                })}
                input={{
                  name: "search",
                  value: createdByNamePattern,
                  onChange: (e) => setCreatedByNamePattern(e.target.value),
                }}
              /> */}
            </div>
            <List
              pageQuery={query}
              handlePageChange={handlePageChange}
              handleOnSortChange={handleOnSortChange}
              loading={action === "list" && requesting}
              data={notificationLogs || []}
              totalRecords={totalCount}
              // handleRowClick={(data) => {
              //   if (!isFromAssigment) {
              //     navigate(
              //       `${RouteConstants.APP_ROUTE_ADMINISTRATION_AUDIENCES_EDIT.replace(
              //         ":id",
              //         data?.data?.id
              //       )}`
              //     );
              //   } else {
              //     navigate(
              //       `${RouteConstants.APP_ROUTE_ASSIGNMENTS_AUDIENCE.replace(
              //         ":id",
              //         data?.data?.id
              //       )}`
              //     );
              //   }
              // }}
              selectionMode=""
              columns={[
               
                {
                  field: "notificationName",
                  header: "Notification Name",
                   sortable: true,
                },
                 {
                  field: "name",
                  header: "User Name",
                   sortable: true,
                },
                 {
                                 field: "isSent",
                                 header: "status",
                                  sortable: true,
                                 body: ListCellRenders.SentStatus,
                               },
                 {
                  field: "triggeredOn",
                  header: "Executed-On",
                   sortable: true,
                   body: ListCellRenders.DateTime("triggeredOn"),
                },
                 {
                  field: "createdOn",
                  header: "Created-On",
                   sortable: true,
                  body: ListCellRenders.DateTime("createdOn"),
                },
                {
                  field: "createdByName",
                  header: "Created-by",
                   sortable: true,
                //   body: ListCellRenders.CreatedBy,
                },
                {
                  field: "updatedOn",
                  header: "Updated-On",
                   sortable: true,
                //   body: ListCellRenders.DateTime("createdAt"),
                body: ListCellRenders.DateTime("updatedOn"),
                },
                {
                  field: "updatedByName",
                  header: "Updated-By",
                   sortable: true,
                //   body: ListCellRenders.DateTime("updatedAt"),
                },
                // {
                //   field: "actions",
                //   headerIcon: "pi-cog",
                //   align: "center",
                //   body: ListCellRenders.OtherActions(otherActions),
                // },
              ]}
            />
          </div>
        </div>
      </div>
      {/* <Dialog
        style={{
          width: isMobile ? "90vw" : "70vw",
          minWidth: isMobile ? "auto" : "800px",
          height: "80vh",
          minHeight: "500px",
        }}
        visible={isUserListDialogVisible}
        onHide={() => setUserListDialogVisible(false)}
        header={intl.formatMessage(
          { id: "audience_users" },
          { name: audiences.find((a) => a.id === selectedId)?.name }
        )}
      >
        <AudienceUserList audienceId={selectedId} />
      </Dialog>
      <ConfirmDialog /> */}
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state?.self?.user,
  audiences: state?.audiences?.data?.list || [],
  action: state?.notifications?.action,
  requesting: state?.notifications?.requesting,
  error: state?.notifications?.error,
  query: state?.notifications?.query,
  totalCount: state?.notifications?.data?.totalCount,
  notificationLogs: state?.notifications?.data?.list || [],
  filters: state?.users?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  listRequest: (query) => dispatch(listRequest(query)),
  setQuery: (query) => dispatch(setQuery(query)),
  deleteRequest: (data) => dispatch(deleteRequest(data)),
//   getNotificationLogs: () => dispatch({ type: "notifications/GetNotificationLogs" }),
  getNotificationLogs: (query) =>
    dispatch({ type: "notifications/GetNotificationLogs", payload: query }),
//   userExportRequest: (data) => dispatch(userExportRequest(data)),
  notificationExportRequest: (data) => dispatch(notificationExportRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationLogList);
